import Colors from "assets/Colors";
import PieChartCustom from "components/common/PieChart";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import NoDataPlaceHolder from "components/common/NoDataPlaceHolder";
import { useBusinessContext } from "../../../BusinessApp";

function MoneyLine({ color, text, total = 0, last }) {
  const { currencyFormat } = useBusinessContext();
  return (
    <s.MoneyLine last={last}>
      <s.ContainerColorPaymentType>
        <s.RoundColor style={{ background: color }} />
        <s.PaymentTypeText>{text}</s.PaymentTypeText>
      </s.ContainerColorPaymentType>
      <s.Money>{currencyFormat(total)}</s.Money>
    </s.MoneyLine>
  );
}

function PieChartCategory({
  orderItemCategorySummary,
  loadingCategories,
  firstGraph,
}) {
  const { t } = useTranslation();
  const data = [];

  const other = {
    name: t("general.others"),
    value: 0,
    color: `${Colors.primary_web_color1}`,
    background: `${Colors.primary_web_color1}15`,
  };

  const categoriesToShow = 3;
  let shownCategories = 0;

  orderItemCategorySummary.forEach((item) => {
    if (shownCategories < categoriesToShow) {
      shownCategories++;
      data.push({
        name: item.name,
        value: item.total,
        color:
          shownCategories === 1 ? Colors.text_on_primary : Colors.text_primary,
        background:
          shownCategories === 1
            ? `${Colors.primary_web}`
            : shownCategories === 2
            ? `${Colors.primary_web_color1}90`
            : `${Colors.primary_web_color1}40`,
      });
    } else {
      other.value += item.total;
    }
  });

  if (other.value > 0) {
    data.push(other);
  }

  return (
    <s.Container>
      <s.Title>
        {t("components.ReportsSalesByCategoryReport.bestSellingCAtegories")}
      </s.Title>
      {!loadingCategories ? (
        <>
          {orderItemCategorySummary.length > 0 ? (
            <s.BodyContainer ref={firstGraph}>
              <s.body>
                <s.LeftBodyContainer>
                  {data.map((item, index) => {
                    if (index > 3) return null;
                    return (
                      <MoneyLine
                        key={index}
                        color={
                          index === 0
                            ? `${Colors.primary_web}`
                            : index === 1
                            ? `${Colors.primary_web_color1}90`
                            : index === 2
                            ? `${Colors.primary_web_color1}40`
                            : `${Colors.primary_web_color1}15`
                        }
                        text={item?.name}
                        total={item?.value}
                      />
                    );
                  })}
                </s.LeftBodyContainer>
              </s.body>

              <s.pieChartContainer>
                <PieChartCustom data={data} />
              </s.pieChartContainer>
            </s.BodyContainer>
          ) : (
            <NoDataPlaceHolder height="260px" />
          )}
        </>
      ) : (
        <Loading height="260px" size="middle" />
      )}
    </s.Container>
  );
}

export default PieChartCategory;
